import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';

import * as Search from '@app/models/search';

import { UrlService } from '@core/services/url/url.service';
import * as fromProjectsState from '@app/store/state/projects/projects.state';
import * as fromProjectsActions from '@app/store/state/projects/projects.actions';

@Injectable({
    providedIn: 'root'
})
export class LogbookService {

    constructor(private url : UrlService,  protected http: HttpClient) {}

    getProperties$(eventId: string) {
        return this.http
        .get(this.url.build("/events/" + eventId + "/properties"));
    }


    /**
     * @deprecated Use ProjectsService.selectProjectFilesNotesCounter() instead
     * to retrieve annotations counter from the store and avoid duplicate API calls
     */
    getProjectFilesNotes$(id: number,prefix: string = ''){
        return this.http
        .get(this.url.build("/projects/" + id + "/annotations"));
    }

}

@Injectable({
    providedIn: 'root'
})
export class LogbookFiltersService {

    constructor(private store: Store<fromProjectsState.Projects>, private actions$: Actions) {}

    // load = (query: string) => this.store.dispatch( new fromProjectsActions.LoadFilters());

    selectEvents = (): Observable<Search.SearchAvailableFilters> => this.store.select(fromProjectsState.projectLogbookAvailableFilterEventsSelector);

    selectUsers = ():  Observable<Search.SearchAvailableFilters> => this.store.select(fromProjectsState.projectLogbookAvailableFilterUsersSelector);
}

@Injectable({
    providedIn: 'root'
})
export class LogbookSearchService {

    constructor(private store: Store<fromProjectsState.Projects>, private actions$: Actions) {}

    applyFilter = (filter: Search.SearchAppliedFilter) => this.store.dispatch( new fromProjectsActions.ApplyLogbookSearchFilter(filter));

    removeFilter = (filter: Search.SearchAppliedFilter) => this.store.dispatch( new fromProjectsActions.RemoveLogbookSearchFilter(filter));

    setTerm = (term: string) => this.store.dispatch( new fromProjectsActions.SetLogbookSearchTerm(term));

    selectFilters = () :  Observable<Search.SearchAppliedFilter[]> => this.store.select(fromProjectsState.projectLogbookSearchFiltersSelector);

    selectTerm = () :  Observable<string> => this.store.select(fromProjectsState.projectLogbookSearchTermSelector);

    selectSearchStatus = ():  Observable<boolean> => this.store.select(fromProjectsState.projectLogbookSearchActiveSelector);

    clear = () => this.store.dispatch( new fromProjectsActions.ClearLogbookSearch());

    

}